import { gql } from "@apollo/client";

export const GET_ADMIN_PROFILE = gql`
	query GetAdminProfile {
		getAdminProfile {
			id
			email
			name
			role {
				id
				name
			}
			permissions
		}
	}
`;
